export class AppInput extends HTMLElement {
  static get observedAttributes() {
    return ["label", "type", "placeholder", "value", "disabled", "required", "error", "helper", "prefix-icon", "suffix-icon"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  get value(): string {
    const input = this.querySelector("input");
    return input ? input.value : "";
  }

  set value(val: string) {
    const input = this.querySelector("input");
    if (input) {
      input.value = val;
    }
  }

  private render() {
    const label = this.getAttribute("label") || "";
    const type = this.getAttribute("type") || "text";
    const placeholder = this.getAttribute("placeholder") || "";
    const value = this.getAttribute("value") || "";
    const disabled = this.hasAttribute("disabled");
    const required = this.hasAttribute("required");
    const error = this.getAttribute("error") || "";
    const helper = this.getAttribute("helper") || "";

    const id = `input-${Math.random().toString(36).substring(2, 9)}`;

    this.innerHTML = `
      <div class="form-group">
        ${label ? `<label for="${id}" class="form-label ${required ? "required" : ""}">${label}</label>` : ""}
        <div style="position: relative; display: flex; align-items: center;">
          <input
            id="${id}"
            type="${type}"
            class="form-input ${error ? "error" : ""}"
            placeholder="${placeholder}"
            value="${value}"
            ${disabled ? "disabled" : ""}
            ${required ? "required" : ""}
          />
        </div>
        ${error ? `<span class="form-error">${error}</span>` : ""}
        ${helper && !error ? `<span class="form-helper">${helper}</span>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-input")) {
  if (!customElements.get("app-input")) {
    customElements.define("app-input", AppInput);
  }
}
